import axios from "axios";
import { stateProps } from "../types";
import { createJWTToken } from "../utils/createJWTToken";
import dataURLtoFile from "../utils/ImageConvertor";

export const doctorCreate = async (doctorInfo: stateProps) => {
  const {
    title,
    firstName,
    lastName,
    email,
    degree,
    regiNumber,
    qualifications,
    speciality,
    practising,
    bankName,
    branchName,
    acntHolder,
    acntNumber,
    gender,
    price,
    // pcurrency,
    phone,
    languages,
    timeslot,
    // boardCertified,
    // termsAndConditions,
    signatureImage,
    profileImage,
    nicImage,
    sealImage,
    slmcCertificateImage,
    // slmcIDImage,
    // proofOfQualificationImage,
  } = doctorInfo;

  const { id } = speciality;
  let specialityId = "";
  if (id !== undefined) {
    specialityId = id.toString();
  }

  const accountNumber = acntNumber.toString();
  let selected_langs = "";
  if (languages.length !== 0) {
    languages.forEach((language) => {
      if (language.status === true) {
        let languageId = language.id.toString();
        if (selected_langs === "") {
          selected_langs = languageId;
          return;
        }
        if (selected_langs !== "") {
          selected_langs = selected_langs.concat("," + languageId);
          return;
        }
      }
    });
  }

  let gender_id = "";
  if (gender === "Male") {
    gender_id = "0";
  } else if (gender === "Female") {
    gender_id = "1";
  } else {
    gender_id = "2";
  }

  // image store as base64 if send post request convert to File
  var photo_signature_file = dataURLtoFile(signatureImage, "photo_signature");
  var photo_nic_file = dataURLtoFile(nicImage, "photo_nic");
  var photo_profile_file = dataURLtoFile(profileImage, "photo_profile");
  var photo_seal_file = dataURLtoFile(sealImage, "photo_seal");
  // for optional image uploading
  var photo_medical_licence_file =
    slmcCertificateImage !== ""
      ? dataURLtoFile(slmcCertificateImage, "photo_medical_licence")
      : null;

  var doctorValue: any = new FormData();
  doctorValue.append("first_name", firstName);
  doctorValue.append("last_name", lastName);
  doctorValue.append("email", email);
  doctorValue.append("gender", gender_id);
  doctorValue.append("title", title);
  doctorValue.append("specialty", specialityId);
  doctorValue.append("phone", phone);
  doctorValue.append("medical_school", degree);
  doctorValue.append("qualification", qualifications);
  doctorValue.append("fee", price);
  doctorValue.append("reg_no", regiNumber);
  doctorValue.append("bank_acc_name", acntHolder);
  doctorValue.append("bank_accont_no", accountNumber);
  doctorValue.append("bank_name", bankName);
  doctorValue.append("branch", branchName);
  doctorValue.append("is_portal", "0");
  doctorValue.append("registration_body", "SLMC");
  doctorValue.append("selected_langs", selected_langs);
  doctorValue.append("practice_location", practising);
  doctorValue.append("photo_signature", photo_signature_file);
  doctorValue.append("photo_nic", photo_nic_file);
  doctorValue.append("photo_profile", photo_profile_file);
  doctorValue.append("photo_medical_licence", photo_medical_licence_file);
  doctorValue.append("photo_seal", photo_seal_file);

  // available times form data
  timeslot.forEach((availableDayTime, id) => {
    if (availableDayTime.status && availableDayTime.timeslots.length > 0) {
      availableDayTime.timeslots.forEach((dayTime) => {
        doctorValue.append((id + 1).toString(), dayTime);
      });
    }
  });

  return axios.post(process.env.REACT_APP_BACKEND_URL + "/api/v1/doctors", doctorValue, {
    headers: {
      Authorization: "bearer " + createJWTToken(),
    },
  });
};
